module.exports = __webpack_public_path__ + "img/129.d96b1f3e.jpg";